/* eslint-disable camelcase */
import React from "react";
import { object, array, bool, string } from "prop-types";
import get from "lodash/get";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { useSelector } from "react-redux";
import { DfpComponent } from "../../ads/dfp-component";
import { HeroStory } from "./HeroStory";
import { OtherStory } from "./OtherStory";
import { AdSlot, NativeAd } from "./ads";
import { RowSeparator } from "../../atoms/RowSeparator";

import "./top-component-section-page.m.css";

const ThirdColumnLeft = ({
  stories,
  show_read_time,
  show_timestamp,
  show_story_separator,
  show_column_separator,
  enable_native_ad,
  deviceType,
  headlineStyles,
  sectionSlug,
  showImagesInMobile,
}) => {
  if (stories.length < 1 && enable_native_ad) {
    return <NativeAd showBorder={show_story_separator} />;
  }

  if (stories.length < 1) {
    return null;
  }

  return (
    <div styleName="third-column-left" style={{ borderRight: show_column_separator || "none" }}>
      {stories.map((story, index) => (
        <OtherStory
          key={story.id}
          story={story}
          showReadTime={show_read_time}
          showTimestamp={show_timestamp}
          showBorder={show_story_separator}
          headlineStyles={headlineStyles}
          sectionSlug={sectionSlug}
          showImagesInMobile={showImagesInMobile}
        />
      ))}
      {enable_native_ad && deviceType && <NativeAd showBorder={show_story_separator} />}
    </div>
  );
};

ThirdColumnLeft.propTypes = {
  stories: array,
  show_read_time: bool,
  show_timestamp: bool,
  show_story_separator: bool,
  show_column_separator: bool,
  enable_native_ad: bool,
  deviceType: string,
  headlineStyles: object,
  sectionSlug: string,
};

export const TopComponentSectionPage = ({ collection, stories, extraProp = "" }) => {
  if (!stories.length) {
    return null;
  }

  const {
    show_timestamp,
    show_read_time,
    show_subheadline_of_first_story,
    show_column_separator,
    show_story_separator,
    show_row_separator,
    enable_row_ad,
    show_row_ad_unit,
    enable_native_ad,
    show_newsletter,
    show_row_ad_unit_bottom,
    show_images_in_mobile,
  } = get(collection, ["associated-metadata"], {});
  const filteredStories = enable_native_ad ? stories.slice(0, 12) : stories.slice(0, 13);
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const deviceType = useDeviceType();
  const { height, width } =
    deviceType === "mobile" || deviceType === "desktop"
      ? { height: "250px", width: "300px" }
      : { height: "600px", width: "300px" };
  const sectionSlug = extraProp;
  return (
    <div className="row-component" styleName="top-component-section-page">
      <div styleName="columns">
        <div
          styleName="stories-column"
          style={{
            borderBottom: `${show_story_separator || "none"}`,
          }}
        >
          <div
            styleName="first-column"
            style={{
              borderRight: `${(deviceType !== "mobile" && show_column_separator) || "none"}`,
              borderBottom: `${(deviceType === "mobile" && show_story_separator) || "none"}`,
            }}
          >
            <HeroStory
              story={filteredStories[0]}
              showSubheadline={show_subheadline_of_first_story}
              showReadTime={show_read_time}
              showTimestamp={show_timestamp}
              showSeparator={show_story_separator}
              sectionSlug={sectionSlug}
            />
            <div styleName="top-stories">
              {filteredStories.slice(1, 3).map((story, index) => (
                <OtherStory
                  key={story.id}
                  story={story}
                  showReadTime={show_read_time}
                  showTimestamp={show_timestamp}
                  showBorder={
                    (deviceType !== "mobile" && show_column_separator) ||
                    (deviceType === "mobile" && show_story_separator)
                  }
                  showThumbnail={true}
                  defaultFallback={true}
                  customStyleName={"top-story"}
                  headlineStyles={{ fontSize: deviceType === "mobile" ? "18px" : "16px" }}
                  sectionSlug={sectionSlug}
                  showImagesInMobile={show_images_in_mobile}
                />
              ))}
            </div>
          </div>
          <div
            styleName="second-column"
            style={{
              border: `${
                (deviceType !== "mobile" && show_column_separator) ||
                (deviceType === "mobile" && show_story_separator) ||
                "none"
              }`,
            }}
          >
            {filteredStories.slice(3, 5).map((story, index) => (
              <>
                {index === 1 && deviceType === "mobile" && enable_row_ad && (
                  <div styleName="ad-wrapper">
                    <AdSlot
                      showNewsletter={false}
                      height={height}
                      width={width}
                      deviceType={deviceType}
                      rowAdDetails={show_row_ad_unit}
                    />
                  </div>
                )}
                <OtherStory
                  key={story.id}
                  story={story}
                  showReadTime={show_read_time}
                  showTimestamp={show_timestamp}
                  showBorder={show_story_separator || deviceType !== "mobile" || index < 1 || !enable_row_ad}
                  headlineStyles={{ fontSize: deviceType === "mobile" ? "20px" : "16px" }}
                  sectionSlug={sectionSlug}
                  showImagesInMobile={show_images_in_mobile}
                />
              </>
            ))}

            {filteredStories.slice(5, 9).map((story, index) => (
              <>
                {index === 3 && deviceType === "mobile" && enable_row_ad && (
                  <div styleName="ad-wrapper">
                    <AdSlot
                      showNewsletter={false}
                      height={height}
                      width={width}
                      deviceType={deviceType}
                      rowAdDetails={show_row_ad_unit}
                      id={"top-component-section-page-row-ad-300x600-2"}
                    />
                  </div>
                )}
                <OtherStory
                  key={story.id}
                  story={story}
                  showReadTime={show_read_time}
                  showTimestamp={show_timestamp}
                  showBorder={show_story_separator && (deviceType !== "mobile" || index < 4)}
                  headlineStyles={{ fontSize: deviceType === "mobile" ? "20px" : "16px" }}
                  sectionSlug={sectionSlug}
                  showImagesInMobile={show_images_in_mobile}
                />
              </>
            ))}
            {deviceType === "desktop" && (
              <ThirdColumnLeft
                stories={filteredStories.slice(9, enable_native_ad ? 10 : 11)}
                show_read_time={show_read_time}
                show_timestamp={show_timestamp}
                show_story_separator={show_story_separator}
                show_column_separator={show_column_separator}
                enable_native_ad={enable_native_ad}
                deviceType={deviceType}
                headlineStyles={{ fontSize: "16px" }}
                sectionSlug={sectionSlug}
                showImagesInMobile={show_images_in_mobile}
              />
            )}
          </div>
          {deviceType === "tablet" && enable_row_ad && (
            <div styleName="ad-wrapper">
              <AdSlot
                showNewsletter={false}
                height={250}
                width={300}
                deviceType={deviceType}
                rowAdDetails={show_row_ad_unit}
              />
            </div>
          )}
          <div
            styleName="third-column"
            style={{
              borderTop: `${(show_story_separator && (deviceType !== "tablet" || !enable_row_ad)) || "none"}`,
              marginTop: `${deviceType !== "tablet" || !enable_row_ad || 0}`,
            }}
          >
            {deviceType !== "desktop" && (
              <ThirdColumnLeft
                stories={filteredStories.slice(9, enable_native_ad ? 10 : 11)}
                show_read_time={show_read_time}
                show_timestamp={show_timestamp}
                show_story_separator={show_story_separator}
                show_column_separator={show_column_separator}
                enable_native_ad={enable_native_ad}
                deviceType={deviceType}
                headlineStyles={{ fontSize: deviceType === "mobile" ? "20px" : "18px" }}
                sectionSlug={sectionSlug}
                showImagesInMobile={show_images_in_mobile}
              />
            )}
            {deviceType === "desktop" && enable_row_ad && (
              <div styleName="ad-wrapper">
                <AdSlot
                  showNewsletter={show_newsletter}
                  height={show_newsletter ? 250 : 600}
                  width={300}
                  deviceType={deviceType}
                  rowAdDetails={show_row_ad_unit}
                />
              </div>
            )}
            {filteredStories.length > 9 && (
              <div styleName="third-column-right">
                {filteredStories.slice(enable_native_ad ? 10 : 11).map((story, index) => (
                  <OtherStory
                    key={story.id}
                    story={story}
                    showReadTime={show_read_time}
                    showTimestamp={show_timestamp}
                    showBorder={show_story_separator && index !== 1}
                    headlineStyles={{ fontSize: deviceType === "mobile" ? "20px" : "18px" }}
                    sectionSlug={sectionSlug}
                    showImagesInMobile={show_images_in_mobile}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

TopComponentSectionPage.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

TopComponentSectionPage.storyLimit = 13;
